import { apiCall, apiCallNotify } from '@/store/utils';
import { State } from '@/store/state';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { TippspielState } from './state';
import { api } from '../api';
import { ITippspielTippSave } from '../types';
import { commitSetLeaderboard, commitSetMatches, commitSetMyTipp } from './mutations';

type MainContext = ActionContext<TippspielState, State>;

export const actions = {
  async actionGetTippspielMatches(context: MainContext) {
    const response = await apiCall(context, api.getMatches);
    commitSetMatches(context, response.data);
  },
  async actionSaveTipp(context: MainContext, payload: ITippspielTippSave) {
    const response = await apiCallNotify(
      context,
      token => api.saveTipp(token, payload.matchId, payload.goalsTeam1, payload.goalsTeam2),
      { loadingText: null, successText: 'Tipp gespeichert' },
    );
    commitSetMyTipp(context, response.data);
  },
  async actionGetTippspielLeaderboard(context: MainContext) {
    const response = await apiCall(context, api.getLeaderboard);
    commitSetLeaderboard(context, response.data);
  },
};

const { dispatch } = getStoreAccessors<TippspielState | any, State>('');

export const dispatchGetTippspielMatches = dispatch(actions.actionGetTippspielMatches);
export const dispatchSaveTipp = dispatch(actions.actionSaveTipp);
export const dispatchGetTippspielLeaderboard = dispatch(actions.actionGetTippspielLeaderboard);
